import { render, staticRenderFns } from "./invitationAndExchange.vue?vue&type=template&id=20280b12&scoped=true&"
import script from "./invitationAndExchange.vue?vue&type=script&lang=js&"
export * from "./invitationAndExchange.vue?vue&type=script&lang=js&"
import style0 from "./invitationAndExchange.vue?vue&type=style&index=0&id=20280b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20280b12",
  null
  
)

export default component.exports